import React, { FC } from 'react';
import { Trans } from 'react-i18next';

import { SUPPORTED_BROWSERS } from 'src/front/constant';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background: ${({ theme }) => theme.palette.dark50};
`;

const ErrorContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;

  box-sizing: border-box;
  min-width: 400px;
  max-width: 600px;

  padding: 24px;
  border: 1px solid ${({ theme }) => theme.palette.paleGreyTwo};
  border-radius: 6px;
  box-shadow: 0 12px 24px 0px ${({ theme }) => theme.palette.dark15};
  transform: translate(-50%, -50%);

  background-color: ${({ theme }) => theme.palette.white};

  overflow-wrap: break-word;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    width: 75%;
    min-width: 0;
  }
`;

const Title = styled.div`
  display: flex;
  justify-content: center;

  padding-bottom: 10px;
`;

const TitleText = styled.span`
  margin-left: 10px;

  color: ${({ theme }) => theme.palette.butterscotch};

  ${({ theme }) => `font-family: ${theme.fonts.GothamMedium};`}
  font-size: 22px;
  line-height: 22px;
`;

const BodyText = styled.p`
  margin: 15px 0;

  color: ${({ theme }) => theme.palette.black};

  ${({ theme }) => `font-family: ${theme.fonts.GothamLight};`}
  text-align: center;
`;

const BrowserList = styled.ul`
  display: flex;
  width: 100%;
  padding: 0;
  justify-content: center;
  list-style-type: none;
`;

const Browsers = styled.li`
  display: flex;
  flex-direction: column;

  padding: 7px 7px 0;
  border-radius: 6.6px;
  margin: 0 5px;
`;

const BrowserName = styled.label`
  padding: 10px 0px 8px;

  color: ${({ theme }) => theme.palette.black};

  font-size: 16px;
`;

const BrowserErrorModal: FC = () => (
  <Overlay>
    <ErrorContainer>
      <Title>
        <TitleText>
          <Trans i18nKey="login_browserNotSupported_title" />
        </TitleText>
      </Title>
      <BodyText>
        <Trans i18nKey="login_browserNotSupported_text" />
      </BodyText>
      <BrowserList>
        <Browsers>
          {SUPPORTED_BROWSERS.map((browser: string) => (
            <BrowserName>{browser}</BrowserName>
          ))}
        </Browsers>
      </BrowserList>
    </ErrorContainer>
  </Overlay>
);

export default BrowserErrorModal;
